<div>
    <div class="text-img">
      Asociado (a) <br>
      Seleccione en la barra de arriba la opci&oacute;n con la cual desea realizar su donaci&oacute;n. <br><br>

      &iexcl;Gracias por sumarse a la fuerza de la cooperaci&oacute;n&#33;
      
    </div>

    <div class="fondo-img">
      <img src="{{fondoImgSrc}}" alt="avatar">
    </div>
  </div> 


// WEBPACK FOOTER //
// ./src/app/pages/index/index.component.html